export default __webpack_public_path__ + "static/NashR-249d2b97edf54e9b9ad517d4acde70a9.png";